export default function(src, size) {
  if (size === null || size === 'master') {
    return src;
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];

    return `${prefix[0]}_${size}${suffix}`;
  }

  return null;
}